const SELECTOR_DIALOG = "dialog.bewertung-filter-overlay-dialog";
const SELECTOR_FILTER_INPUT = "input.filter-input";
const SELECTOR_FILTER_CHECKBOX = 'input.filter-input[type="checkbox"]';
const SELECTOR_ANWENDEN = '[interaction="filter-anwenden"]';
const SELECTOR_ALLE_LOESCHEN = '[interaction="filter-entfernen-alle"]';

const EVENT_FILTER_AND_SORT_CHANGED = "bewertungen-artikeldetail-overlay-filter-changed";
const EVENT_FILTER_AND_SORT_SELECTED = "bewertungen-artikeldetail-filter-and-sort-selected";

const SORT_DEFAULT = "RELEVANZ";

// RED-12573: Sekundär-Button schaltet um – Löschen bei aktiven Filtern, sonst Abbrechen
const LABEL_ALLE_LOESCHEN = "Alle Filter löschen";
const LABEL_ABBRECHEN = "Abbrechen";

class BewertungFilterOverlay extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector(SELECTOR_DIALOG);
    this.alleLoeschenButton = this.querySelector(SELECTOR_ALLE_LOESCHEN);
    this.bindEvents();
    this.updateAlleLoeschenButton();
  }

  get isBuchhaendler() {
    return this.hasAttribute("data-buchhaendler");
  }

  bindEvents() {
    this.querySelector(SELECTOR_ANWENDEN)?.addEventListener("click", () =>
      this.onAnwenden(),
    );
    this.alleLoeschenButton?.addEventListener("click", () =>
      this.onAlleLoeschenOderAbbrechen(),
    );
    // RED-12573: Checkbox-Auswahl bestimmt, ob der Button löscht oder abbricht
    this.addEventListener("change", (event) => {
      if (event.target.matches(SELECTOR_FILTER_CHECKBOX)) {
        this.updateAlleLoeschenButton();
      }
    });
    // Schließen (X im Header) läuft nativ über command="close" commandfor — kein JS-Handler nötig.
    this.dialog?.addEventListener("close", () => this.onDialogClose());
    document.addEventListener(EVENT_FILTER_AND_SORT_SELECTED, (event) =>
      this.onSelectedReceived(event.detail),
    );
  }

  onDialogClose() {
    // Das globale Seiten-Skript entfernt body.dialog-open bei JEDEM Dialog-close,
    // ohne offene Overlays zu zählen. Solange der umschließende Dialog noch offen
    // ist, muss der Body-Scroll-Lock erhalten bleiben.
    const elternDialog = this.closest("dialog");
    if (elternDialog?.open) {
      requestAnimationFrame(() => document.body.classList.add("dialog-open"));
    }
  }

  onAnwenden() {
    document.dispatchEvent(
      new CustomEvent(EVENT_FILTER_AND_SORT_CHANGED, {
        detail: {
          buchhaendler: this.isBuchhaendler,
          filterAndSort: this.getFilterAndSort(),
        },
      }),
    );
    this.dialog?.close();
  }

  onAlleLoeschen() {
    this.querySelectorAll(SELECTOR_FILTER_CHECKBOX).forEach((node) => {
      node.checked = false;
    });
    this.setSort(SORT_DEFAULT);
  }

  // RED-12573: Bei aktiven Filtern löschen, sonst Overlay abbrechen/schließen
  onAlleLoeschenOderAbbrechen() {
    if (this.hatAktiveFilter()) {
      this.onAlleLoeschen();
      this.updateAlleLoeschenButton();
    } else {
      this.dialog?.close();
    }
  }

  hatAktiveFilter() {
    return this.querySelector(`${SELECTOR_FILTER_CHECKBOX}:checked`) !== null;
  }

  updateAlleLoeschenButton() {
    if (this.alleLoeschenButton) {
      this.alleLoeschenButton.textContent = this.hatAktiveFilter()
        ? LABEL_ALLE_LOESCHEN
        : LABEL_ABBRECHEN;
    }
  }

  // Haupt-Overlay sendet buchhaendler als String -> exakt die alte Semantik: nur die Kunden-Variante
  // übernimmt die Vorauswahl (z.B. vorausgewählte Sterne aus dem Sterne-Slider).
  onSelectedReceived(detail) {
    if (!this.isBuchhaendler && detail?.filterAndSort) {
      this.applyState(detail.filterAndSort);
      this.updateAlleLoeschenButton();
    }
  }

  applyState(filterAndSort) {
    this.querySelectorAll(SELECTOR_FILTER_CHECKBOX).forEach((node) => {
      node.checked = filterAndSort.get(node.name)?.has(node.value) ?? false;
    });
    const sortSet = filterAndSort.get("sort");
    this.setSort(
      sortSet && sortSet.size > 0 ? Array.from(sortSet)[0] : SORT_DEFAULT,
    );
  }

  setSort(sortValue) {
    this.querySelectorAll('input.filter-input[name="sort"]').forEach((node) => {
      node.checked = node.value === sortValue;
    });
  }

  getFilterAndSort() {
    const state = new Map([
      ["s", new Set()],
      ["f", new Set()],
      ["sort", new Set()],
    ]);
    this.querySelectorAll(`${SELECTOR_FILTER_INPUT}:checked`).forEach((node) => {
      state.get(node.name)?.add(node.value);
    });
    if (state.get("sort").size === 0) {
      state.get("sort").add(SORT_DEFAULT);
    }
    return state;
  }
}

customElements.get("bewertung-filter-overlay") ||
  customElements.define("bewertung-filter-overlay", BewertungFilterOverlay);
